import {ChangeDetectionStrategy, Component} from '@angular/core';

import {UsersModule} from './../../users/users.module';

@Component({
  selector: 'user-profile',
  standalone: true,
  imports: [UsersModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileComponent {}
